import { Box, Grid, LinearProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Gridstyles } from '../ApplicationDetails';
import { useDispatch } from 'react-redux';
import { KeyValue } from '../ApplicationDetails/contributor';
import { AuthorisedSignatories } from '../../redux-store/types/api-types';
import { getAuthorisedSignatoryById } from '../../redux-store/actions/userManagement';
import { Location } from 'history';
import { styles } from '../../Styles/styles';
import { BackButtonAndHeader } from './userBackButton';
import { AddressFieldReadonly } from './AddressFields';

export default function AuthorisedSignatoryDetails({
  location,
}: {
  location: Location<{ authorisedSignatoryId: number }>;
}): JSX.Element {
  const { authorisedSignatoryId: id } = location.state || { authorisedSignatoryId: null };
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [authorisedSignatoryDetails, setAuthorisedSignatoryDetails] =
    useState<AuthorisedSignatories>();

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        if (id) {
          const getAuthorisedSignatoryDetails = (await dispatch(
            getAuthorisedSignatoryById(id)
          )) as unknown as AuthorisedSignatories;
          setAuthorisedSignatoryDetails(getAuthorisedSignatoryDetails);
        }
        if (!isComponentActive) {
          return;
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  return (
    <>
      <Box sx={styles.UsersFormikBox}>
        <BackButtonAndHeader
          User="Authorised Signatories"
          accessForEditAdd={true}
          onClickBack={() =>
            history.push('authorised-signatory', {
              distributorId: authorisedSignatoryDetails?.distributorId,
            })
          }
          onClickEdit={() =>
            history.push('edit-authorised-signatory', {
              authorisedSignatoryId: authorisedSignatoryDetails?.id,
            })
          }
        />
        {isLoading ? (
          <LinearProgress sx={{ ml: 5, mr: 5 }} />
        ) : (
          authorisedSignatoryDetails && (
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 }, pt: 1 }}>
              <React.Fragment>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue
                      title={'Name'}
                      description={authorisedSignatoryDetails.user.firstName}
                    />
                    <KeyValue
                      title={'Email Id'}
                      description={authorisedSignatoryDetails.user.email}
                    />
                    <KeyValue
                      title={'Mobile Number'}
                      description={authorisedSignatoryDetails.user.phone}
                    />
                    <KeyValue title={'Pan'} description={authorisedSignatoryDetails.panNumber} />
                    <AddressFieldReadonly AddressField={authorisedSignatoryDetails} />
                  </Grid>
                </Gridstyles>
              </React.Fragment>
            </Grid>
          )
        )}
      </Box>
    </>
  );
}
